import { GlobalDesignAction } from '../types';
import { cornerGrouping } from './grouping';
import CornerLobbyItem from './CornerLobbyItem';
import CornerStyles from './CornerStyles';

const cornerAction: GlobalDesignAction<'cornerStyles'> = {
  panel: CornerStyles,
  lobbyItem: CornerLobbyItem,
  grouping: cornerGrouping,
};

export default cornerAction;
